import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  BankAdjustmentSearchCriteria,
  PageListBean,
  RestBankAdjustmentBeanRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { AccountPayableService } from "../services/AccountPayableService.js";

import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
export class BankAdjustmentLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new BankAdjustmentSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let bankAdjustmentLookupCriteria = new BankAdjustmentSearchCriteria();
    bankAdjustmentLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = BankAdjustmentLookupCriteraHandler(
      companyCode,
      bankAdjustmentLookupCriteria
    );
    let newCriteria = new BankAdjustmentSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      bankAdjustmentLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getBankAdjustmentStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "adjustmentNumber", 0, true); //1
    this.addColumnDefinition("Status", "status", 0, false); //3
    this.addColumnDefinition("Reason", "reasonCode", 0, false); //2
    this.addColumnDefinition("AdjustmentAmount", "adjustmentAmount", 1, false); //3
    this.addColumnDefinition("BankCode", "bankCode", 0, false); //3
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false);
  }
  loadBankAdjustmentList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new BankAdjustmentSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.adjustmentNumber = searchCriteria.adjustmentNumber;
      criteria.status = searchCriteria.status;
      criteria.adjustmentNumberContains =
        searchCriteria.adjustmentNumberContains;
      criteria.adjustmentNumberStartsWith =
        searchCriteria.adjustmentNumberStartsWith;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestBankAdjustmentBeanRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    AccountPayableService.getBankAdjustmentPageList(
      requestInput,
      (response) =>
        this.loadBankAdjustmentListResponse(response, lookup_dialog),
      this.loadBankAdjustmentListError
    );
  };
  loadBankAdjustmentListResponse = (response, lookup_dialog) => {
    let bankList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.bankAdjustmentPageList != null &&
      response.data.bankAdjustmentPageList.bankAdjustments !== null
    ) {
      bankList = response.data.bankAdjustmentPageList.bankAdjustments;
      totalCount = response.data.bankAdjustmentPageList.totalCount;
      currentPageNumber = response.data.bankAdjustmentPageList.currentPage;
      pageSize = response.data.bankAdjustmentPageList.pageSize;
      bankList.map((bk) => {
        bk.status = ModuleUtils.getBankAdjustmentStatusCaption(bk.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = bankList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadBankAdjustmentListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.adjustmentNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.adjustmentNumberContains = filterText;
        this.searchCriteria = new BankAdjustmentSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadBankAdjustmentList(lookup_dialog, pageNumber, search);
    }
  }
}
const BankAdjustmentLookupCriteraHandler = (
  companyCode,
  bankAdjustmentLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new BankAdjustmentSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new BankAdjustmentSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>AdjustmentNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  ref={this.focusRef}
                  id="adjustmentNumber"
                  name="adjustmentNumber"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>AdjustmentNumber StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentNumberStartsWith"
                  name="adjustmentNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>AdjustmentNumber Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentNumberContains"
                  name="adjustmentNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"A"}>Approved</option>
                </FormControl>
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
